import type { NextRouter } from 'next/router';
import type {
  RouteChangeCompleteHandler,
  RouteChangeStartHandler,
} from './types';

export const subscribeRouteChangeStart = (
  events: NextRouter['events'],
  handler: RouteChangeStartHandler,
): (() => void) => {
  events.on('routeChangeStart', handler);
  return () => {
    events.off('routeChangeStart', handler);
  };
};

export const subscribeRouteChangeComplete = (
  events: NextRouter['events'],
  handler: RouteChangeCompleteHandler,
): (() => void) => {
  events.on('routeChangeComplete', handler);
  return () => {
    events.off('routeChangeComplete', handler);
  };
};
